<template>
    <div class="card">
        <div class="card-body">
            <div class="row">
                <div class="col">
                    <div :class="errorClass('quiniela.torneo')">
                        <label>Torneo</label>
                        <select
                            v-model="finalQuiniela.torneo"
                            class="form-control"
                        >
                            <option v-for="torneo in torneos" :value="torneo">
                                {{ torneo.nombre }}
                            </option>
                        </select>
                        <span
                            class="text-danger"
                            v-if="
                                validationErrors.hasOwnProperty(
                                    'quiniela.torneo'
                                )
                            "
                            >{{ validationErrors["quiniela.torneo"][0] }}</span
                        >
                    </div>
                </div>
                <div class="col">
                    <div :class="errorClass('quiniela.tipo')">
                        <label>Tipo</label>
                        <select
                            v-model="finalQuiniela.tipo"
                            class="form-control"
                        >
                            <option v-for="tipo in tipos" :value="tipo">
                                {{ tipo.nombre }}
                            </option>
                        </select>
                        <span
                            class="text-danger"
                            v-if="
                                validationErrors.hasOwnProperty('quiniela.tipo')
                            "
                            >{{ validationErrors["quiniela.tipo"][0] }}</span
                        >
                    </div>
                </div>
            </div>
            <br />
            <div class="row">
                <div class="col">
                    <div :class="errorClass('quiniela.nombre')">
                        <label for="nombre">Nombre</label>
                        <input
                            type="text"
                            class="form-control"
                            id="nombre"
                            v-model="finalQuiniela.nombre"
                        />
                        <span
                            class="text-danger"
                            v-if="
                                validationErrors.hasOwnProperty(
                                    'quiniela.nombre'
                                )
                            "
                            >{{ validationErrors["quiniela.nombre"][0] }}</span
                        >
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-4">
                    <div :class="errorClass('quiniela.banner')">
                        <label>Logo</label>
                        <vue-dropzone
                            id="dzBanner"
                            ref="dzBanner"
                            v-on:vdropzone-success="dzSuccessBanner"
                            :options="dzOptionsBanner"
                        />
                        <span
                            class="text-danger"
                            v-if="
                                validationErrors.hasOwnProperty(
                                    'quiniela.banner'
                                )
                            "
                            >{{ validationErrors["quiniela.banner"][0] }}</span
                        >
                    </div>
                </div>
                <div class="col-8">
                    <div
                        v-if="finalQuiniela.banner"
                        style="float:left; margin-right: 10px margin-top: 10px;"
                    >
                        <img :src="static + finalQuiniela.banner" width="300" />
                        <button
                            class="btn btn-danger btn-image btn-sm"
                            @click="removeBanner()"
                        >
                            <i class="fa fa-times"></i>
                        </button>
                    </div>
                </div>
            </div>
            <br />
            <div class="row">
                <div class="col">
                    <label>Banner</label>
                    <vue-dropzone
                        id="dzBanner2"
                        ref="dzBanner2"
                        v-on:vdropzone-success="dzSuccessBanner2"
                        :options="dzOptionsBanner"
                    />
                </div>
            </div>
            <br />
            <div class="row" v-if="finalQuiniela.banners.length > 0">
                <div class="col">
                    <table class="table table-sm table-bordered table-striped">
                        <thead>
                            <tr>
                                <th>Imágen</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            <quiniela-banner
                                v-for="(banner, i) of finalQuiniela.banners"
                                :key="i"
                                :banner="banner"
                                :banners="finalQuiniela.banners"
                                :static="static"
                            />
                        </tbody>
                    </table>
                </div>
            </div>
            <br />
            <div class="row">
                <div class="col">
                    <div class="form-group form-check">
                        <input
                            type="checkbox"
                            class="form-check-input"
                            id="active"
                            v-model="finalQuiniela.activa"
                        />
                        <label class="form-check-label" for="active"
                            >Activa</label
                        >
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-3">
                    <div :class="errorClass('quiniela.codigos')">
                        <label for="codigos">Crear códigos</label>
                        <input
                            type="text"
                            class="form-control"
                            id="codigos"
                            v-model="finalQuiniela.codigos"
                        />
                        <span
                            class="text-danger"
                            v-if="
                                validationErrors.hasOwnProperty(
                                    'quiniela.codigos'
                                )
                            "
                            >{{ validationErrors["quiniela.codigos"][0] }}</span
                        >
                    </div>
                </div>
            </div>
        </div>
        <div class="card-footer text-right">
            <button :class="buttonClass()" @click="save">Guardar</button>
        </div>
    </div>
</template>

<script>
import QuinielaBanner from "../components/QuinielaBanner.vue";
import vueDropzone from "vue2-dropzone-vue3";
import axios from "axios";
import { errorsMixin } from "../mixins/errors.js";

export default {
    props: ["quiniela", "tipos", "torneos", "static"],
    mixins: [errorsMixin],
    data() {
        return {
            saving: false,
            finalQuiniela: {
                quinielaid: 0,
                torneo: null,
                tipo: null,
                nombre: null,
                banner: null,
                banners: [],
                activa: null,
            },
            dzOptionsBanner: {
                url: "/upload/banners",
                maxFilesize: 5.0,
                acceptedFiles: ".jpg, .jpeg, .png",
                createImageThumbnails: false,
                dictDefaultMessage:
                    "<i class='fa fa-cloud'></i> ARRASTRAR IMAGEN PARA AGREGAR",
                headers: {
                    "X-CSRF-TOKEN": document.querySelector(
                        'meta[name="csrf-token"]'
                    ).content,
                },
            },
            validationErrors: {
                quiniela: null,
            },
        };
    },
    mounted() {
        this.finalQuiniela = this.quiniela;
    },
    methods: {
        dzSuccessBanner(file, response) {
            this.finalQuiniela.banner = response.url;
        },
        dzSuccessBanner2(file, response) {
            this.finalQuiniela.banners.push(response);
        },
        removeBanner() {
            this.finalQuiniela.banner = null;
        },
        save() {
            axios
                .post("/quinielas/quinielas", this.finalQuiniela)
                .then((response) => {
                    location.replace("/quinielas/quinielas");
                })
                .catch((err) => {
                    this.handleError(err);
                    // this.processing = false;
                    // alert(error);
                });
        },
    },
    components: {
        vueDropzone,
        QuinielaBanner,
    },
};
</script>
